import React from 'react';

const ActiveFilterChip = ({label, onRemove}) => (
    <button type="button" className="filter-main" aria-label={`Remove ${label} filter`} onClick={onRemove}>
        <span className="filter-badge">
            <span className="filter-badge-label">{label}</span>
            <span className="filter-badge-remove" aria-hidden="true">&times;</span>
        </span>
    </button>
);

export default ActiveFilterChip;
